import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ClearAll as ClearAllIcon } from '@mui/icons-material';

interface CloseAllTabsButtonProps {
  onCloseAll: () => void;
  disabled?: boolean;
}

const CloseAllTabsButton: React.FC<CloseAllTabsButtonProps> = ({
  onCloseAll,
  disabled = false,
}) => {
  return (
    <Tooltip title="Cerrar todas las pestañas" arrow>
      <IconButton
        size="small"
        onClick={onCloseAll}
        disabled={disabled}
        sx={{
          color: '#6b7280',
          backgroundColor: 'transparent',
          borderRadius: '6px',
          minWidth: '32px',
          minHeight: '32px',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: '#ef4444',
            backgroundColor: '#fef2f2',
            transform: 'scale(1.05)',
          },
          '&:disabled': {
            color: '#d1d5db',
            backgroundColor: 'transparent',
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        }}
        aria-label="Cerrar todas las pestañas"
      >
        <ClearAllIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default CloseAllTabsButton;
